import BookingDetailInfo from './BookingDetailInfo';
import CalendarDayItem from './CalendarDayItem';
import CalendarDayMusicHallItem from './CalendarDayMusicHallItem';
import CalendarWeekItem from './CalendarWeekItem';
import CalendarWeekMusicHallItem from './CalendarWeekMusicHallItem';
import CustomerInfo from './CustomerInfo';
import PaymentInfo from './PaymentInfo';
import QrCodeItem from './QrCodeItem';
import RoomInfo from './RoomInfo';
import ScoreBlock from './ScoreBlock';
import StatusInfo from './StatusInfo';

const EXPORT = {
  BookingDetailInfo,
  CalendarDayItem,
  CalendarDayMusicHallItem,
  CalendarWeekItem,
  CalendarWeekMusicHallItem,
  CustomerInfo,
  PaymentInfo,
  QrCodeItem,
  RoomInfo,
  ScoreBlock,
  StatusInfo,
};

export default EXPORT;
